<template>
  <div class="content">
    <div class="box">
      <p style="display: flex;justify-content: space-between;">
        <span> <i class="line"></i>运营统计</span>
        <span style="font-size: 26px;">{{userName}}</span>
      </p>
    </div>
    <div class="order">
      <div class="lists" style="background:#36A3F7;">
        <div class="amount">
          <p style="color:#fff">订单数量</p>
          <p style="font-size: 18px;">
            <el-statistic>
                <template slot="formatter">
                  {{ordernumber}}
                </template>
            </el-statistic>
            <!-- <countTo :startVal="startVal" :endVal="ordernumber" :duration="2000"></countTo> -->
            
          </p>
        </div>
      </div>
      <div class="lists" style="background:#30C7C9;">
        <div class="amount">
          <p style="color:#fff">订单金额</p>
          <p style="font-size: 18px;">
            <!-- <countTo :startVal="startVal" :endVal="orderamount" :duration="2000" :decimals="1"></countTo> -->
            <el-statistic>
                <template slot="formatter">
                  {{orderamount}}
                </template>
            </el-statistic>
          </p>
        </div>
      </div>
      <div class="lists" style="background:#B6A2DE;">
        <div class="amount">
          <p style="color:#fff">佣金金额</p>
          <p style="font-size: 18px;">
            <!-- <countTo :startVal="startVal" :endVal="ordercommission" :duration="2000" :decimals="1"></countTo> -->
            <el-statistic>
                <template slot="formatter">
                  {{ordercommission}}
                </template>
            </el-statistic>
          </p>
        </div>
      </div>
      <div class="lists" style="background:#F39494;" v-if="adminShow">
        <div class="amount">
          <p style="color:#fff">补卡金额</p>
          <p style="font-size: 18px;">
            <el-statistic>
                <template slot="formatter">
                  {{changeCardAmount}}
                </template>
            </el-statistic>
          </p>
        </div>
      </div>
      <div class="lists" style="background:#E6A23C;" v-show="adminShow">
        <div class="amount">
          <p style="color:#fff">停机保号</p>
          <p style="font-size: 18px;">
            <el-statistic>
                <template slot="formatter">
                  {{keepCardAmount}}
                </template>
            </el-statistic>
          </p>
        </div>
      </div>
      <div class="lists listsxianshi" style="background:#0099CC;" v-show="adminShow">
        <div class="amount">
          <p style="color:#fff">总金额</p>
          <p style="font-size: 18px;">
            <el-statistic>
                <template slot="formatter">
                  {{totalAmount}}
                </template>
            </el-statistic>
          </p>
        </div>
      </div>

    </div>
    <div class="nian">
      <h3><i class="line"></i>订单统计</h3>
      <div style="text-align: right;margin-top:14px;">
        <span v-for="(item,index) in data" :key="index" :class="{cur: activeIndex === index}" @click="checkCard(item,index)">{{item}}</span>
      </div>
    </div>
    <div id="main" class="simpleDemo"></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { lineChart } from "@/api/dashboard";//金额柱形图
export default {
  data() {
    return {
      startVal: 0,
      orderamount: 0,
      ordernumber: 0,
      ordercommission:0,
      keepCardAmount:0,
      changeCardAmount:0,
      totalAmount:0,
      jzzlyAmount:"",
      jzzlAmount:"",
      jzzlzxAmount:"",
      activeIndex: 0,
      data: ["日","月","年"],
      commissionAmountList:[], //佣金列表
      orderAmountList: [], //订单金额
      orderNumberList: [], //订单数量
      timeList: [], //时间
      userName:'',
      userId:'',
    };
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    }
  },
  methods: {
    // 金额柱形图
    listEcharts() {
      setTimeout(() => {
        var option = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            y: "470px",
          },
          color: [ "#36A3F7","#B6A2DE",'#30C7C9',],
          xAxis: [
            {
              type: "category",
              data: this.timeList,
              axisPointer: {
                type: "shadow",
              },
              axisLine: {
                //坐标轴轴线相关设置。
                lineStyle: {
                  color: "#2B2F3A",
                }
              },
              axisLabel: {
                interval:0,
                rotate:0//角度顺时针计算的
              }
            },
          ],
          yAxis: {
            nameTextStyle: {
              color: "#FA6F53",
              fontSize: 16,
              padding: [0, 0, 10, 0]
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#2B2F3A"
              }
            },
            type: "value"
          },
          animationDuration: 2000, //动画时间
          animationEasing: 'BounceOut',  //BounceOut设置动画效果 cubicInOut
          series: [
            {
              name: "订单数量",
              type: "bar", //line  bar
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.orderNumberList,
            },
            {
              name: "佣金金额",
              type: "bar",
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.commissionAmountList,
            },
            {
              name: "订单金额",
              type: "bar",
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.orderAmountList,
            },
          ],
        };
        var myChart = echarts.init(document.getElementById("main"));
        option && myChart.setOption(option);
        window.addEventListener("resize",function(){
          myChart.resize();
        });
      },800)
    },
    // 金额柱形图切换年月日
    checkCard(val, index) {
      this.activeIndex = index;
      this.getOrderInfo(val);
    },
    // 金额柱形图切换年月日
    getOrderInfo(type = "日") {
      let params = {
        type: type,
        userId:this.userId
      };
      lineChart(params).then(res => {
        if (res.data.code == 200) {
          this.timeList = res.data.data.timeList;
          this.orderAmountList = res.data.data.orderAmountList;
          this.orderNumberList = res.data.data.orderNumberList;
          this.commissionAmountList = res.data.data.commissionAmountList;
          this.ordernumber = Number(res.data.data.normalNumber);//订单数
          this.orderamount = res.data.data.normalAmount;//订单金额
          this.ordercommission = res.data.data.commissionAmount;//佣金
          if(this.adminShow){
            this.keepCardAmount = Number(res.data.data.keepCardAmount);//停机保号金额
            this.changeCardAmount = Number(res.data.data.changeCardAmount);//补卡金额
            if(!!res.data.data.orderAppNameHashList){
              this.jzzlAmount = Math.round(res.data.data.orderAppNameHashList[1].appMoneyCount);
              this.jzzlyAmount = Math.round(res.data.data.orderAppNameHashList[0].appMoneyCount);
              this.jzzlzxAmount = Math.round(res.data.data.orderAppNameHashList[2].appMoneyCount);
            }
            this.totalAmount = Number(res.data.data.normalAmount) + Number(res.data.data.keepCardAmount) + Number(res.data.data.changeCardAmount);//总金额
          }
          this.listEcharts(); 
        }
      });
    },
    // js千位分割
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    },
  },
  mounted() {
    this.userId = this.$route.query && this.$route.query.userId;
    this.userName = this.$route.query && this.$route.query.username;
    this.$nextTick(function () {
      this.getOrderInfo();
    })
  },
  created() {

  }
};
</script>
<style scoped lang="less">
  .beianhao{
    width:100%;
    font-size:16px;
    text-align: center;
    margin-top: 80px;
    margin-bottom: 30px;
  }
  .content{
    padding: 20px 7% 20px;
  }
  .box {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: left;
  }
  .line{
    width: 2px;
    height: 16px;
    line-height: 16px;
    background-color: #626365;
    display: inline-block;
    margin-right: 10px;
  }
  .box p span {
    font-size: 20px;
    color: #626365;
    font-weight: 300;
  }
  .order {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
  }
  .order .lists {
    width: 13.3%;
    height: 108px;
    cursor: pointer;
    display: flex;
    background:#30C7C9;
    border-radius: 10px;
  }
  .listsxianshi{
    position: relative;
  }
  .money-none{
    position: absolute;
    right: -65px;
    top: 15px;
    animation: dongHua normal 1.2s ease-in-out;
    p{
      width: 135px;
      font-size: 14px;
      text-align: left;
    }
  }
  @-webkit-keyframes dongHua {
    0% {
        opacity:0.1;
    }
    25% {
        opacity:0.25;
    }
    50% {
        opacity:0.5;
    }
    75% {
        opacity:0.75;
    }
    100% {
        opacity:1;
    }
  }
  .down-class{
    display: flex;
    flex-direction: column ;
    color:#666666;
    div{
      width: 100%;
      height: 54px;
    }
    .left{
      text-align: center;
      position: relative;
      left: 15px;
      top:10px
    }
    .right{
      text-align: center;
      position: relative;
      right: 30px;
    }
  }
  .imgs {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .amount {
    flex: 1;
    height: 108px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .amount p {
    font-size: 18px;
    color: #666666;
    font-weight: bold;
    margin-top: 5px;
  }
  .cur {
    color: #fff;
    background-color:#30C7C9;
    border-color:#30C7C9;
  }
  .content {
    width: 100%;
  }
  .nian {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  .nian h3{
    text-align: left;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    color: #626365;
    font-weight: 300;
  }
  .nian span {
    display: inline-block;
    width: 56px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    margin-left: 10px;
    font-size: 14px;
    border-radius: 4px;
  }
  .simpleDemo {
    width: 100%;
    height: 500px;
    margin-top: 10px;
    background: #fff;
    border: 1px solid rgba(83,130,152,.2);
  }
  .liuclass {
    text-align: left;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    color: #626365;
    font-weight: 300;
    margin-top: 20px;
  }
  .card-class{
    width: 100%;
    height: 320px;
    display: flex;
    .white-box{
      width: 32%;
      .cardEcharts-class{
        width: 100%;
        height: 300px;
        // border: 1px solid rgba(83,130,152,.2);
      }
    }
    .white1{
      width: 68%;
      .white2{
        width: 75%;
        height: 320px;
        display: inline-block;
        .cardEcharts-class{
          height: 300px;
        }
      }
      .white3{
        width: 25%;
        height: 320px;
        display: inline-block;
        position: relative;
        top:-40px;
        p{
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: #E7EAF3;
          font-size: 14px;
          color: #899caf;
          margin: 0 auto;
        }
        .table-head{
          display: flex;
          justify-content: space-between;
          background: #F7F5F0;
          margin-top: 5px;
        }
        ul{
          li{
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: space-between;
            color: #3398db;
            font-size: 14px;
            cursor: pointer;
            .number1-bg{
              display: inline-block;
              width: 16px;
              height: 16px;
              line-height: 18px;
              text-align: center;
              color: #fff;
              background: #fb973b;
              margin-right: 3px;
            }
          }
        }
      }
    }
  }
  .yunyingshang-class{
    display: flex;
    justify-content: space-between;
    div{
      width: 28%;
      height: 150px;
      border: 1px solid #dcdfe6;
      font-size: 22px;
      background: #fff;
      color: #626365;
      p{
        text-align: center;
        height: 75px;
        line-height: 75px;
      }
    }
  }
  @media screen and (max-width: 750px){
    .box p span{
      font-size: 22px;
    }
    .order{
      margin-top: 40px;
      flex-direction: column;
    }
    .lists{
      width: 100%!important;
      margin-top: 3px;
    }
    .panel-block{
      flex-direction: column;
    }
    .white-box{
      width: 100%!important;
    }
    .wrapl{
      width: 100%!important;
    }
    .wrapr{
      display: inline!important;
    }
    .flow-class{
      display: none;
    }
    .cardtj-class{
      display: none;
    }
    .money-none{
      position: absolute;
      right: -15px;
      top: 15px;
      p{
        width: 135px;
        font-size: 14px;
        text-align: right;
      }
    }
  }
</style>


